module.exports = __webpack_public_path__ + "media/images/flags/1x1/afg-5e3955baaa8024dcb92632aff694d6a1.svg";